<template>
    <div class="grcform">
    </div>
</template>

<script>


export default {
  name: 'frmBlank',
  components: {
  },
  props: {
  },
  data () {
      return {
      }
  },
  model: {
  },  
  methods:{

    SetLang()
    {

    },


  },
  created()
  {

  },
  mounted()
  {

  }

}


</script>


<style scoped>

</style>